<template>
  <footer class="row">
    <div class="col-xs-12">
      <ul class="list-inline">
        <li>Last update: {{ LastUpdate }}</li>
        <li>© 2019 Chevron Corporation</li>
        <li>Company Confidential</li>
        <li>OpCo : <a href="https://thailandupstream.chevron.com/">Chevron Thailand</a></li>
      </ul>
      <ul class="list-inline">
        <li>Content contact: <a href="#">Chevron Template Admin</a></li>
        <li>Technical contact: <a href="mailto:itsupport@chevron.com">Global IT Service Desk</a></li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'fepmt-footer',
  computed: {
    LastUpdate () {
      // console.log('FooterComponent/process.env :', process.env)
      let lastupDate = process.env.NODE_DATE
      if (lastupDate !== '' || lastUpdate !== null|| lastUpdate !== undefined) {
        // console.log('FooterComponent/lastupDate : Has value')
        return lastupDate
      } else {
        return null
      }
    }
  }
}
</script>


<style lang='scss' scoped>
footer {
  background: #ededee;
  padding: 23px 20px;
  font-family: 'GothamHTF-Book', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 12px;
  text-align: center;

  ul li {
    list-style-type: none;
  }

  .list-inline {
    margin-left: 0px;
    margin-bottom: 10px;
  }

  .list-inline > li {
    border-right: 1px solid #dbdcdd;
    padding-right: 13px;
    padding-left: 12px;
    line-height: 0.93em;
  }
}

.row {
    margin-left: 0px;
    margin-right: 0px;
}

.col-xs-12 {
    width: 100%;
}

.list-inline {
    padding-left: 0px;
    margin-left: -5px;
    list-style: none;
}

.list-inline > li {
    display: inline-block;
    padding-right: 5px;
    padding-left: 5px;
}
</style>
